import { render } from "./BaseArrayCheckbox.vue?vue&type=template&id=7cc863c7&ts=true"
import script from "./BaseArrayCheckbox.vue?vue&type=script&lang=ts"
export * from "./BaseArrayCheckbox.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__